import { createAction } from '@reduxjs/toolkit'

import { AnalysisGeneration } from 'types/AnalysisGeneration'

// tryGetGenerations
export const getAll = createAction('get_analysis_generation_overview')
export const getAllSuccess = createAction<AnalysisGeneration[]>(
  'get_analysis_generation_overview_success'
)
export const getAllFailed = createAction(
  'get_analysis_generation_overview_failed'
)

// tryStartGeneration
export const trigger = createAction('trigger_analysis_generation')
export const triggerSuccess = createAction<AnalysisGeneration>(
  'trigger_analysis_generation_success'
)
export const triggerFailed = createAction('trigger_analysis_generation_failed')

// tryCancelGeneration
export const cancelSuccess = createAction<AnalysisGeneration>(
  'cancel_analysis_generation_success'
)

// tryPollGeneration — a tracked generation reached a terminal status
export const finished = createAction<AnalysisGeneration>(
  'analysis_generation_finished'
)

// A finished generation the user has seen, in a dialog or the notifier
export const dismissCompleted = createAction<string>(
  'analysis_generation_dismiss_completed'
)

// A run dialog open on an analysis type shows its outcome in place
export const follow = createAction<string>('analysis_generation_follow')
export const unfollow = createAction<string>('analysis_generation_unfollow')
